<section class="flex flex-col page-wrapper">
  <div class="w-full py-4 block sm:hidden shrink-0">
    <go-back></go-back>
  </div>
  <div class="w-full relative slider">
    <div class="slides" #slidesContainer [style.transform]="slidesTransform()">
      @for (slide of preparedSlides(); track slide.title ?? slide.type) {
        <div
          class="slide"
          [class.active]="$index === activeSlideIndex()"
          [attr.inert]="$index !== activeSlideIndex() ? '' : null"
          [attr.aria-hidden]="$index !== activeSlideIndex()"
        >
          @switch (slide.type) {
            @case (SlideType.ID_DOCUMENT) {
              <id-document></id-document>
            }
            @case (SlideType.US_ADDRESS) {
              <us-address></us-address>
            }
            @default {
              <slide-content
                [slide]="slide"
                [$index]="$index"
                [routerUrl]="routerUrl"
                [isLastTutorialSlide]="isTutorial && $index === preparedSlides().length - 1"
                [JourneyRoute]="JourneyRoute"
                [class.journey]="JourneyRoute"
              ></slide-content>
            }
          }
        </div>
      }
    </div>
  </div>
  <slide-control
    [slides]="preparedSlides()"
    [activeSlideIndex]="activeSlideIndex()"
    [isPrevDisabled]="isPrevDisabled()"
    [isNextDisabled]="isNextDisabled()"
    [routerUrl]="routerUrl"
    (goToSlide)="goToSlide($event)"
    (onPrevClick)="onPrevClick()"
    (onNextClick)="onNextClick()"
  ></slide-control>
</section>
